import { useEffect, useState } from "react";
import { set, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Badge, Button, Col, DropdownMenu, DropdownToggle, Form, Row, UncontrolledDropdown } from "reactstrap";
import {
  AddTopDoctorsAPI,
  createLabCategory,
  getDoctorsList,
  getLabCategory,
  updateLabCategory,
} from "../../api/master/indes";
import { BASE_URL_IMG } from "../../assets/constants";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  PreviewAltCard,
  TooltipComponent,
  UserAvatar,
} from "../../components/Component";
import useLogout from "../../hooks/useLogout";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import ViewImage from "../../MyComp/UI/modals/ViewImage";
import { updateDoctorAPI } from "../../api/doctor";
import ApiPaginationDataTable from "../../MyComp/UI/DataTable/ApiPaginationDataTable";
import { getSmartInitials } from "../../utils/Utils";
import { UserAvatarCell } from "../../MyComp/ImageView/UserAvatarCell";
import TopConfirmationModal from "../../MyComp/UI/modals/TopConfirmationModal";
const User = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      server_search: "",
      page: 1,
      limit: 25,
    },
  });

  const { logout } = useLogout();
  const navigate = useNavigate();
  // Separate table state from form
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [mode, setMode] = useState("Add");
  const [imageOpen, setImageOpen] = useState(false);
  //pagination
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);

  // pagination
  const handlePerRowsChange = (newPerPage, page) => {
    const rows = isNaN(newPerPage) ? totalRows : newPerPage;
    setPerPage(rows);
    setValue("page", page);
    console.log("rows", page, rows);
  };
  const handlePageChange = (page) => {
    console.log("page", page);
    setPerPage(perPage);
    setCurrentPage(page);
    setValue("page", page);
  };

  const MAX_DOCTORS = 20;
  const [selectedDoctors, setSelectedDoctors] = useState([]);
  useEffect(() => {
    if (!tableData?.length) return;

    setSelectedDoctors((prev) => {
      const prevIds = new Set(prev.map((d) => d.id));

      const preSelected = tableData.filter((row) => row?.isSelected && !prevIds.has(row.id));

      return [...prev, ...preSelected];
    });
  }, [tableData]);

  // const handleDoctorSelect = (row, checked) => {
  //   setSelectedDoctors((prev) => {
  //     if (checked) {
  //       if (prev.length + 2 >= MAX_DOCTORS) {
  //         toast.warning("You cannot select more than 20 doctors.");
  //         return prev;
  //       }

  //       if (prev.some((d) => d.id === row.id)) return prev;

  //       return [...prev, row];
  //     }

  //     return prev.filter((d) => d.id !== row.id);
  //   });

  //   setTableData((prev) => prev.map((item) => (item.id === row.id ? { ...item, isSelected: checked } : item)));

  //   // if (!checked) {
  //   //   deleteTopDoctor(row.doctorId);
  //   // }
  // };

  const handleDoctorSelect = (row, checked) => {
    if (!checked) {
      // 👉 UNSELECT CASE
      setLoading(true);

      const body = {
        doctors: [row.doctorId],
        isSelected: false,
      };

      AddTopDoctorsAPI(body)
        .then((res) => {
          if (res?.data?.status === true) {
            toast.success("Doctor removed from Top Doctors");

            // remove from selectedDoctors
            setSelectedDoctors((prev) => prev.filter((d) => d.id !== row.id));

            // update tableData
            setTableData((prev) => prev.map((item) => (item.id === row.id ? { ...item, isSelected: false } : item)));
          } else {
            toast.error(res?.data?.message);
          }
        })
        .catch(() => {
          toast.error("Error removing doctor");
        })
        .finally(() => setLoading(false));

      return; // ❗ important
    }

    // 👉 SELECT CASE
    setSelectedDoctors((prev) => {
      if (prev.length >= MAX_DOCTORS) {
        toast.warning("You cannot select more than 20 doctors.");
        return prev;
      }

      if (prev.some((d) => d.id === row.id)) return prev;

      return [...prev, row];
    });

    setTableData((prev) => prev.map((item) => (item.id === row.id ? { ...item, isSelected: true } : item)));
  };

  const handleRemoveTopDoctors = () => {
    if (selectedDoctors.length === 0) {
      toast.warning("Please select at least one doctor to remove.");
      return;
    }

    setLoading(true);

    const doctorIds = selectedDoctors.map((d) => d.doctorId);

    const body = {
      doctors: doctorIds,
      isSelected: false,
    };

    AddTopDoctorsAPI(body)
      .then((res) => {
        const status = res?.data?.status;

        if (status === true) {
          setSelectedDoctors([]);
          serverSideSearch();
          toast.success("Doctor(s) removed from Top Doctors.");
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res?.data?.message || "Failed to remove doctors.");
        }
      })
      .catch((err) => {
        console.error("Remove top doctors error:", err);
        toast.error("Something went wrong. Please try again.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const renderStars = (rating = 0) => {
    const totalStars = 5;

    return (
      <>
        {[...Array(totalStars)].map((_, i) => {
          const fillPercent = Math.min(Math.max(rating - i, 0), 1) * 100;

          return (
            <span
              key={i}
              style={{
                position: "relative",
                display: "inline-block",
                fontSize: "16px",
                color: "#d1d5db",
                marginRight: "1px",
              }}
            >
              ★
              <span
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: `${fillPercent}%`,
                  overflow: "hidden",
                  color: "#f59e0b",
                  whiteSpace: "nowrap",
                }}
              >
                ★
              </span>
            </span>
          );
        })}
      </>
    );
  };

  const columns = [
    {
      name: "",
      width: "30px",
      cell: (row) => {
        const isApproved = String(row?.kyc_status).toLowerCase() === "approved";

        const isChecked = selectedDoctors.some((d) => d.id === row.id);

        const isLimitReached = !isChecked;

        return (
          <input
            type="checkbox"
            checked={isChecked}
            disabled={!isApproved}
            onChange={(e) => handleDoctorSelect(row, e.target.checked)}
            title={
              !isApproved
                ? "Only approved doctors can be selected"
                : selectedDoctors.length >= MAX_DOCTORS && !isChecked
                  ? "You can not select more than 20 doctors"
                  : ""
            }
          />
        );
      },
    },
    {
      name: "Name",
      selector: (row) => row?.name,
      cell: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            padding: "6px 0",
          }}
        >
          {/* <img
            src={row?.profile ? `${row.profile}` : "/default-avatar.png"}
            // alt={row?.name || "User"}
            style={{
              width: "45px",
              height: "45px",
              borderRadius: "50%",
              objectFit: "cover",
              border: "2px solid #e5e7eb",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            }}
            onClick={() => handleImageOpenPreview(row?.profile)}
            onError={(e) => {
              e.currentTarget.src = '../../images/avatar/a-sm.jpg'; // direct set fallback
            }}
          /> */}
          <UserAvatarCell
            row={row}
            image={row?.profile}
            name={row?.name}
            handleImageOpenPreview={handleImageOpenPreview}
          />

          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontWeight: 600,
                fontSize: "15px",
                color: "#111827",
                lineHeight: "1.2",
              }}
            >
              {row?.name || "N/A"}
            </span>
            <span
              style={{
                fontSize: "13px",
                color: "#6b7280",
              }}
            >
              {row?.email || "No email"}
            </span>
            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
              <span style={{ fontSize: "13px", fontWeight: 600 }}>{row?.rating ?? "N/A"}</span>

              <span>{renderStars(Number(row?.rating || 0))}</span>
            </div>
          </div>
        </div>
      ),
      sortable: true,
      width: "250px",
    },

    // {
    //   name: "Reg. Number",
    //   selector: (row) => row?.registrationNumber,
    //   sortable: true,
    //   width: "90px",
    // },

    // {
    //   name: "Mobile",
    //   selector: (row) => row?.mobile,
    //   sortable: true,
    //   width: "120px",
    // },
    {
      name: "Mobile",
      sortable: true,
      wrap: false,
      cell: (row) => {
        const fullAddress = row?.mobile || "";

        return (
          <div
            title={fullAddress} // full text on hover
            style={{
              maxWidth: "150px",
              overflow: "hidden",
              cursor: "pointer",
            }}
          >
            {truncateByCharacters(fullAddress, 10)}
          </div>
        );
      },
    },
    // {
    //   name: "DOB",
    //   selector: (row) => row?.dob,
    //   sortable: true,
    // },
    // {
    //   name: "Gender",
    //   selector: (row) => row?.gender,
    //   sortable: true,
    // },
    // {
    //   name: "Qualification",
    //   selector: (row) => (
    //     <>
    //       <div>
    //         <div
    //           className="me-1 my-1 text-wrap text-truncate-1"
    //           color="outline-primary"
    //           title={`${row?.qualification}`}
    //         >
    //           {row?.qualification}
    //         </div>
    //       </div>
    //     </>
    //   ),

    //   sortable: true,
    //   wrap: false,
    //   width:"180px"
    // },
    {
      name: "Qualification",
      sortable: true,
      width: "180px",
      cell: (row) => {
        const fullAddress = row?.qualification || "";

        return (
          <div
            title={fullAddress}
            style={{
              maxWidth: "150px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              cursor: "pointer",
            }}
          >
            {fullAddress}
          </div>
        );
      },
    },

    // {
    //   name: "Specialization",
    //   selector: (row) => (
    //     <>
    //       <div>
    //         {row?.specialization?.map((item, index) => (
    //           <Badge className="me-1 my-1 text-wrap" color="outline-primary">
    //             {item}
    //           </Badge>
    //         ))}
    //       </div>
    //     </>
    //   ),
    //   sortable: true,
    //   wrap: true,
    //   width: "220px",
    // },
    {
      name: "Experience",
      selector: (row) => row?.experience,
      sortable: true,
      // width: "110px",
    },

    // {
    //   name: "Medical Reg. No",
    //   selector: (row) => row?.medical_council_registration_no,
    //   sortable: true,
    // },
    {
      name: "Medical Reg. No",
      sortable: true,
      wrap: false,
      cell: (row) => {
        const fullAddress = row?.medical_council_registration_no || "";

        return (
          <div
            title={fullAddress} // full text on hover
            style={{
              maxWidth: "150px",
              overflow: "hidden",
              cursor: "pointer",
            }}
          >
            {truncateByCharacters(fullAddress, 10)}
          </div>
        );
      },
    },
    {
      name: "KYC",
      selector: (row) => row?.kyc_status,
      cell: (row) => (
        <div
          style={{ cursor: row?.kyc_status == "Approved" ? "pointer" : "default" }}
          onClick={() => (row?.kyc_status == "Approved" ? handleToggleTop(row) : null)}
        >
          <Badge
            className="text-capitalize"
            color={`${
              row.kyc_status == "pending"
                ? "outline-warning"
                : row?.kyc_status == "Approved"
                  ? "outline-primary"
                  : row?.kyc_status == "In Review"
                    ? "outline-info"
                    : "outline-danger"
            }`}
            id={`ttt-${row?.id}`}
          >
            {row?.isSelected && <Icon color={"success"} name={row?.isSelected ? "star" : ""} />} {row.kyc_status}
          </Badge>
          <TooltipComponent
            iconClass="card-hint"
            direction="top"
            id={`ttt-${row?.id}`}
            text={
              row?.status == "pending"
                ? "First Approved the Doctor."
                : row?.isSelected
                  ? "Remove from top 20 list."
                  : "Add to top 20 list."
            }
          />
        </div>
      ),
      sortable: true,
      wrap: true,
      // width: "100px",
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge color={row.status ? "success" : "danger"}>{row.status ? "Active" : "InActive"}</Badge>
        </div>
      ),
      sortable: true,
      // width: "90px",
    },
    {
      name: "Action",
      // width: "120px",
      cell: (row) => (
        <UncontrolledDropdown>
          <DropdownToggle tag="span" className="btn btn-icon btn-trigger" style={{ cursor: "pointer" }}>
            <Icon name="more-h" />
          </DropdownToggle>
          <DropdownMenu style={{ minWidth: "50px", width: "100px", marginRight: "25px" }} end>
            {
              <div className="d-flex flex-column m-1 justify-content-center align-items-center h-100">
                {/* <Button
                  outline
                  style={{ width: "50px" }}
                  color={`warning`}
                  size={`xs`}
                  id={`profile-${row?.id}`}
                  className={`me-1 my-1 d-flex flex-column m-1 justify-content-center align-items-center`}
                  onClick={() => viewDoctorProfile(row)}
                >
                  {" "}
                  <Icon name="eye" />
                </Button>
                <TooltipComponent
                  iconClass="card-hint"
                  direction="top"
                  id={`profile-${row?.id}`}
                  text="View Doctor Detail"
                /> */}
                {/* <Button
                  outline
                  style={{ width: "50px" }}
                  color={row?.is_feature ? `success` : `danger`}
                  size={`xs`}
                  id={`feature-${row?.id}`}
                  className={`me-1 d-flex flex-column m-1 justify-content-center align-items-center`}
                  onClick={() => handleFeatureDoctor(row)}
                >
                  {" "}
                  <Icon name="star" />
                </Button>
                <TooltipComponent
                  iconClass="card-hint"
                  direction="top"
                  id={`feature-${row?.id}`}
                  text="Feature Doctor"
                /> */}
                <Button
                  outline
                  style={{ width: "50px" }}
                  color={`warning`}
                  size={`xs`}
                  className={`me-1 my-1 d-flex flex-column m-1 justify-content-center align-items-center`}
                  id={`edit-${row?.id}`}
                  onClick={() => handleEdit(row)}
                >
                  {" "}
                  <Icon name="edit" />
                </Button>
                {/* {/* <TooltipComponent iconClass="card-hint" direction="top" id={`edit-${row?.id}`} text="Edit Doctor" /> */}
                {row?.kyc_status == "Approved" ? null : (
                  <>
                    <Button
                      outline
                      style={{ width: "50px" }}
                      color={`primary`}
                      size={`xs`}
                      className={`me-1 my-1 d-flex flex-column m-1 justify-content-center align-items-center`}
                      id={`app-${row?.id}`}
                      onClick={() => handleShowDetails(row)}
                    >
                      {" "}
                      <Icon name="box" />
                    </Button>
                    <TooltipComponent
                      iconClass="card-hint"
                      direction="top"
                      id={`app-${row?.id}`}
                      text="Doctor Approval"
                    />
                  </>
                )}
                <Button
                  outline
                  style={{ width: "50px" }}
                  color={`primary`}
                  size={`xs`}
                  className={`me-1 my-1 d-flex flex-column m-1 justify-content-center align-items-center`}
                  id={`kyc-${row?.id}`}
                  onClick={() => handleShowDoctorsDetails(row)}
                >
                  {" "}
                  <Icon name="eye" />
                </Button>
                <TooltipComponent iconClass="card-hint" direction="top" id={`kyc-${row?.id}`} text="Doctor Profile" />
                <Button
                  outline
                  style={{ width: "50px" }}
                  color={`primary`}
                  size={`xs`}
                  className={`me-1 d-flex flex-column m-1 justify-content-center align-items-center `}
                  id={`slot-${row?.id}`}
                  onClick={() => handleSlotManagement(row)}
                >
                  {" "}
                  <Icon name="calendar-booking" />
                </Button>
                <TooltipComponent iconClass="card-hint" direction="top" id={`slot-${row?.id}`} text="Slot Management" />
              </div>
            }
            ,
          </DropdownMenu>
        </UncontrolledDropdown>
      ),
    },
    // {
    //   name: "Action",
    //   width: "100px",
    //   cell: (row) => (
    //     <>
    //       {row?.kyc_status == "Approved" ? null : (
    //         <Button outline color="warning" size="xs" onClick={() => handleEdit(row)}>
    //           <Icon name="edit" />
    //         </Button>
    //       )}
    //       {row?.kyc_status == "Approved" ? null : (
    //         <Button className="mx-1" outline color="success" size="xs" onClick={() => handleShowDetails(row)}>
    //           <Icon name="eye" />
    //         </Button>
    //       )}
    //       <Button
    //         outline
    //         style={{ width: "50px" }}
    //         color={`primary`}
    //         size={`xs`}
    //         className={`me-1 d-flex flex-column m-1 justify-content-center align-items-center `}
    //         id={`slot-${row?.id}`}
    //         onClick={() => handleSlotManagement(row)}
    //       >
    //         {" "}
    //         <Icon name="calendar-booking" />
    //       </Button>
    //       <TooltipComponent iconClass="card-hint" direction="top" id={`slot-${row?.id}`} text="Slot Management" />
    //     </>
    //   ),
    // },
  ];

  const [topModal, setTopModal] = useState(false);
  const handleToggleTop = (row) => {
    setValue("selectedRow", row);
    setTopModal(true);

    console.log("--->", row);
  };
  const handleSlotManagement = (row) => {
    navigate("/doctor/slot-management", { state: { data: row } });
  };
  const handleImageOpenPreview = (row, name) => {
    setImageOpen(!imageOpen);
    setValue("image_preview", row);
    trigger("image_preview");
  };
  const handleImageClose = () => {
    setImageOpen(!imageOpen);
  };
  const handleShowDetails = (row) => {
    console.log("rowEdit", row);
    navigate("/doctorsDetails", { state: { doctorId: row?.doctorId, mode: "Approval" } });
  };
  const handleShowDoctorsDetails = (row) => {
    console.log("row", row);
    navigate("/doctorsDetailsView", { state: { doctorId: row?.doctorId, mode: "Approval" } });
  };
  const getDoctor = (body) => {
    setLoading(true);
    getDoctorsList(body)
      .then((res) => {
        setLoading(false);
        if (res.data.status === true) {
          console.log("doctor list", res.data.data);

          setTableData(res.data.data); // doctor list
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };
  const getLabList = () => {
    setLoading(true);
    getLabCategory()
      .then((res) => {
        setLoading(false);
        if (res.data.status === true) {
          setTableData(res.data.data);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };
  useEffect(() => {
    // getDoctor();
  }, []);
  const onFormSubmit = (formData) => {
    const body = {
      name: formData.name,
      order: Number(formData.order),
      status: formData?.status?.value ?? true,
      ...(mode === "Edit" && { id: selectedRow?.id }),
    };

    setLoading(true);

    const apiCall = mode === "Add" ? createLabCategory(body) : updateLabCategory(body);

    apiCall
      .then((res) => {
        setLoading(false);
        if (res.data.status === true) {
          toast.success(res.data.message);

          if (mode === "Add") {
            const newItem = res.data.data || res.data.newData || null;

            if (newItem && newItem.id) {
              setTableData((prev) => [...prev, newItem]);
            } else {
              getLabList();
            }
          } else {
            setTableData((prev) => prev.map((item) => (item.id === selectedRow.id ? { ...item, ...body } : item)));
          }

          setIsOpen(false);
          setMode("Add");
          reset();
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  const handleEdit = (row) => {
    navigate("/doctorsDetails", { state: { doctorId: row?.doctorId, mode: "Edit" } });
  };

  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    setShowModal(true);
  };

  const confirmStatusChange = () => {
    const formData = new FormData();
    const updatedStatus = watch("selectedRow").status === true ? false : true;
    formData.append("doctorId", watch("selectedRow")?.doctorId);
    formData.append("status", updatedStatus);

    updateDoctorAPI(formData).then((res) => {
      if (res.data.status === true) {
        toast.success(res.data.message);
        toast.clearWaitingQueue();
        serverSideSearch();
        setShowModal(false);
      } else if (res.data.status === false) {
        toast.error(res.data.message);
        toast.clearWaitingQueue();
      } else if (res.data.status === "expired") {
        toast.error(res.data.message);
        toast.clearWaitingQueue();
        logout();
      }
    });
  };
  const genderOption = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
  ];
  useEffect(() => {
    serverSideSearch();
  }, [perPage, currentPage]);
  const serverSideSearch = (data) => {
    const body = {
      search: watch("server_search"),
      page: currentPage,
      limit: perPage,
    };
    setLoading(true);
    getDoctorsList(body)
      .then((res) => {
        const status = res.data.status;
        if (status === true) {
          setLoading(false);
          console.log("server side res", res?.data?.data?.result);
          setTotalRows(res?.data?.data?.totalRecords);
          setValue("limit", res?.data?.data?.totalRecords);
          setTableData(res?.data?.data?.result);
        } else if (status === false) {
          setLoading(false);
          setTableData([]);
        } else if (status === "expired") {
          setLoading(false);
          logout();
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("catch error", err);
      });
  };
  useEffect(() => {
    if (watch("server_search")?.length == 0) {
      serverSideSearch();
    }
  }, [watch("server_search")]);

  const handleAddTopDoctors = () => {
    if (selectedDoctors.length < 5) {
      toast.warning("Please select at least 5 doctors to add to Top Doctors list.");
      return;
    }

    setLoading(true);

    const doctorIds = selectedDoctors.map((d) => d.doctorId);

    const body = {
      doctors: doctorIds,
      isSelected: true,
    };

    AddTopDoctorsAPI(body)
      .then((res) => {
        const status = res?.data?.status;

        if (status === true) {
          setSelectedDoctors([]);
          serverSideSearch();
          toast.success("Top doctors added successfully.");
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res?.data?.message || "Failed to add top doctors.");
        }
      })
      .catch((err) => {
        console.error("Add top doctors error:", err);
        toast.error("Something went wrong. Please try again.");
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleToggleTopDoctor = () => {
    setLoading(true);
    const selectedDoctors = [watch("selectedRow")];

    const doctorIds = selectedDoctors?.map((d) => d.doctorId);
    console.log("ddd", selectedDoctors);
    const body = {
      doctors: doctorIds,
      isSelected: selectedDoctors[0]?.isSelected ? false : true,
    };
    console.log("data", body);

    AddTopDoctorsAPI(body)
      .then((res) => {
        const status = res?.data?.status;

        if (status === true) {
          setSelectedDoctors([]);
          serverSideSearch();
          setValue("selectedRow", "");
          setTopModal(false);
          toast.success("Top doctors added successfully.");
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res?.data?.message, {
            autoClose: 5000,
            closeOnClick: false,
            pauseOnHover: true,
          });
        }
      })
      .catch((err) => {
        console.error("Add top doctors error:", err);
        toast.error(err?.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const truncateByCharacters = (text = "", charLimit = 20) => {
    if (!text) return "";
    return text.length > charLimit ? text.slice(0, charLimit) + "..." : text;
  };

  return (
    <>
      <Head title="Doctors" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                Doctors
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <Button
                color="primary"
                outline
                className="me-n1"
                onClick={() => {
                  navigate("/doctor-registration/basic-details", { state: { mode: "Add" } });
                  // if (!isOpen) {
                  //   setIsOpen(true);
                  //   setMode("Add");
                  //   reset();
                  // } else {
                  //   setIsOpen(false);
                  // }
                }}
              >
                <Icon name={isOpen ? "minus" : "plus"} />
              </Button>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          {/* <MyDataTable data={tableData} columns={columns} title="Doctors List" isLoading={loading} /> */}
          <ApiPaginationDataTable
            columns={columns}
            data={tableData}
            title={"Doctor List"}
            isLoading={loading}
            register={register}
            trigger={trigger}
            watch={watch}
            setValue={setValue}
            errors={errors}
            totalRows={watch("limit")}
            perPage={watch("perPage")}
            serverSearch
            paginationServer
            serverSideSearch={serverSideSearch}
            handlePageChange={handlePageChange}
            handlePerRowsChange={handlePerRowsChange}
            TOPDOC
            MAX_DOCTORS={MAX_DOCTORS}
            selectedDoctors={selectedDoctors}
            handleAddTopDoctors={handleAddTopDoctors}
            deleteTopDoctor={handleRemoveTopDoctors}
          />
        </Block>
      </Content>

      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
        data={watch("selectedRow")}
      />
      <ViewImage url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />

      <TopConfirmationModal
        isOpen={topModal}
        data={watch("selectedRow")}
        toggle={() => setTopModal(false)}
        onConfirm={handleToggleTopDoctor}
      />
    </>
  );
};

export default User;
